export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7116.9d4391a7.jpg";